import { Injectable } from '@angular/core';
import { HisBackendService, GenericValue } from 'hisng';
import { Observable } from 'rxjs';
import { Person } from 'app/fs/res/common/model/person/person';
import { PsvPersonProfile } from 'app/fs/res/common/model/person/psvPersonProfile';

@Injectable()
export class PersonService {

    constructor( private backendService: HisBackendService ) {
    }

    getPersonById( id: number ): Observable<Person> {
        return this.backendService.getData( `api/v1/cs/psv/person/${id}` );
    }

    getPersonProfileByPersonId( id: number ): Observable<PsvPersonProfile> {
        return this.backendService.getData( `api/v1/cs/psv/person/${id}/details` );
    }

    getPersonOrganizationsById( query: string, id?: number ): Observable<GenericValue[]> {
        if ( !query ) {
            return this.backendService.getData( `api/v1/cs/psv/person/${id}/organizations` );
        } else {
            return this.backendService.getData( `api/v1/cs/psv/person/${id}/organizations?q=${encodeURI(query)}` );
        }
    }

    /* save person */
    savePerson( externalPerson: Person ): Observable<Person> {

        let personToSave: Person = new Person();
        personToSave.firstname = externalPerson.firstname;
        personToSave.surname = externalPerson.surname;
        personToSave.gender = externalPerson.gender;

        // XXX Hier sollte vermutlich externalPerson.id abgefragt werden?
        // Beim bisher einzigen Aufruf dieser Methode ist das auch null.
        // Wenn sich das ändert muss im folgenden ein else-Branch implementiert werden!
        let savedPerson: Observable<Person>;
        if ( personToSave.id == null ) {
            savedPerson = this.backendService.postData( 'api/v1/cs/psv/person', personToSave );
        }

        return savedPerson;
    }

    /**
     * let the backend verify the rights if the auth can see person profiles
     * (need to be in BE because we cant check rightsparameter in FE)
     *
     * @param id of person
     * @return Observable.of( true if auth can see person profiles )
     */
    checkForViewPersonProfileRights( id: number ): Observable<boolean> {
        return this.backendService.getData( `api/v1/fs/res/personProfile/hasVisibleAffiliations/${id}` );
    }
}
